module.exports = __webpack_public_path__ + "static/Iron-eagle-gages-adb06fde75344d8b4378917674fdcb6f.png";